import React, { useEffect, useState } from "react";
import "./modalP.scss";
import { Button, Typography } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import Collapse from "@material-ui/core/Collapse";
import { Levels } from "react-activity";
import { useHistory } from "react-router";
import ViewAddress from "./ViewAddress";
import PaypalBtn from "../../Services/PaypalBtn";
import UserData from "./userData";
import requests from "../../Services/HttpServices";
import "react-activity/dist/react-activity.css";

const defaultID = "AVfuTYt59be7cdzYndbKA-64V-L1ALSzzwX3FRfI39COtKTP7SfOwkmrVfS2KAVTMwSGHbGDY6MNrkiF";

const parseAmount = (amount) => {
	const parsed = parseFloat(amount);
	return Number.isNaN(parsed) ? 0 : parsed;
};

const formatAmount = (amount) => parseAmount(amount)
	.toFixed(2)
	.replace(".", ",");

const getLoggedUser = () => {
	try {
		return sessionStorage.getItem("User") && JSON.parse(sessionStorage.getItem("User")).userdata;
	} catch (e) {
		return null;
	}
};

export default function ReactPayPal(props) {
	let taxAddress;
	let taxAddressNationalityFlag               = false;
	let shippingNationalityFlag                 = false;
	const history                               = useHistory();
	const [label, setLabel]                     = useState(null);
	const [loading, setLoading]                 = useState(null);
	const [buttonClicked, setButtonClicked]     = useState(null);
	const [success, setSuccess]                 = useState(null);
	const [addressVisible, setAddressVisible]   = useState(false);
	const [userDataVisible, setUserDataVisible] = useState(false);
	const [dataVisible, setDataVisible]         = useState(false);
	const [creditQuote, setCreditQuote]         = useState(null);
	const [creditError, setCreditError]         = useState("");
	const [useCredits, setUseCredits]           = useState(false);
	const [creditLoading, setCreditLoading]     = useState(false);

	!label && setLabel("QrCode + Pagina Ricordo + Spedizione\n Quantità: 1");
	const effectivePrice = props.price || "1";
	const hasPartnerPrice = props.isPartnerPrice && props.originalPrice && parseFloat(props.originalPrice) > 0;
	const loggedUser = getLoggedUser();
	const isCreditRecharge = props.paymentType === "credits-recharge";
	const hideUserData = props.paymentType === "funeral-gift";
	const canUseCredits = !isCreditRecharge && !!loggedUser && !!props.orderId;
	const totalAmount = creditQuote && creditQuote.total ? parseAmount(creditQuote.total) : parseAmount(effectivePrice);
	const availableCredits = creditQuote ? parseAmount(creditQuote.balance) : 0;
	const hasSufficientCredits = canUseCredits && availableCredits >= totalAmount && totalAmount > 0;
	const creditToUse = hasSufficientCredits && useCredits ? totalAmount : 0;
	const paypalAmount = Math.max(0, totalAmount - creditToUse);

	useEffect(() => {
		if (!canUseCredits) {
			setCreditQuote(null);
			setUseCredits(false);
			setCreditError("");
			setCreditLoading(false);
			return;
		}

		setCreditLoading(true);
		requests("get", "creditOrderQuote", props.orderId)
			.then((result) => {
				const quote = result && result.data && result.data.data;
				if (result && result.data && result.data.response === "success" && quote) {
					setCreditQuote(quote);
					// I crediti sono un'opzione: il checkout PayPal deve restare il
					// comportamento predefinito anche per gli utenti che hanno un saldo.
					setUseCredits(false);
					setCreditError("");
				} else {
					setCreditQuote(null);
					setUseCredits(false);
				}
				setCreditLoading(false);
			})
			.catch(() => {
				setCreditQuote(null);
				setUseCredits(false);
				setCreditLoading(false);
			});
	}, [canUseCredits, props.orderId, props.price]);

	const completeSuccess = (data) => {
		setSuccess(true);
		if (props.onSuccess) props.onSuccess(data);
	};

	const payWithCredits = () => {
		setLoading(true);
		setButtonClicked(true);
		setCreditError("");
		if (props.setError) props.setError(false);
		const bodyData = {
			orderid      : props.orderId,
			creditAmount : creditToUse,
		};
		if (props.memorialType) {
			bodyData.memorialType = props.memorialType;
			bodyData.deceasedID   = props.deceasedId;
		}
		requests("post", "creditPayOrder", bodyData).then((data) => {
			if (data.response === "success") {
				completeSuccess(data);
			} else {
				setLoading(false);
				setCreditError(data.message || "Pagamento con crediti non riuscito.");
			}
		});
	};

	if (props.taxAddress && props.taxAddress.city !== "") taxAddress = props.taxAddress;
	else taxAddress = props.shippingAddress;

	if (
		props.shippingAddress
		&& props.shippingAddress.address !== ""
		&& props.shippingAddress.address
		&& props.shippingAddress.address === props.shippingAddress.civic
	) {
		shippingNationalityFlag = true;
	}
	if (taxAddress && taxAddress.address !== "" && taxAddress.address && taxAddress.address === taxAddress.civic) {
		taxAddressNationalityFlag = true;
	}
	return (
		<div className="payment-main-modal">
			{!loading ? (
				<div>
					<Typography className="header">Riepilogo ordine</Typography>
					<div id="purchase-detail">
						<div id="purchase-description">
							<Typography style={{ textTransform: "capitalize" }}>{props.purchase}</Typography>
							<Typography>
								Quantità:
								{props.quantity}
							</Typography>
						</div>
						<div id="price">
							{hasPartnerPrice ? (
								<div className="payment-price-stack">
									<Typography className="payment-original-price">
										{formatAmount(props.originalPrice)}
										€
									</Typography>
									<Typography>
										{formatAmount(effectivePrice)}
										€
									</Typography>
								</div>
							) : (
								<Typography>
									{formatAmount(effectivePrice)}
									€
								</Typography>
							)}
						</div>
					</div>
					{!isCreditRecharge && (
						<div className="payment-credit-box">
							<label
								className={`payment-credit-toggle${creditLoading || !hasSufficientCredits ? " payment-credit-toggle-disabled" : ""}`}
							>
								<input
									type="checkbox"
									checked={useCredits && hasSufficientCredits}
									disabled={creditLoading || !hasSufficientCredits}
									onChange={(event) => setUseCredits(event.target.checked)}
								/>
								<span>Paga con Crediti DigitalMemorial</span>
							</label>
							{creditLoading ? (
								<Typography className="payment-credit-note">Verifica crediti disponibili...</Typography>
							) : hasSufficientCredits ? (
								<div className="payment-credit-summary">
									<div>
										<span>Totale Ordine</span>
										<strong>{formatAmount(totalAmount)} Crediti</strong>
									</div>
									<div>
										<span>Crediti Disponibili</span>
										<strong>{formatAmount(availableCredits)} Crediti</strong>
									</div>
								</div>
							) : (
								<div className="payment-credit-insufficient">
									<Typography>Crediti Disponibili: {formatAmount(availableCredits)}</Typography>
									<Typography>
										I crediti non sono sufficienti per effettuare questo ordine, ricaricali nella sezione Account!
									</Typography>
								</div>
							)}
						</div>
					)}
					{creditError && <Typography className="payment-credit-error">{creditError}</Typography>}
					{!hideUserData && (
						<div id="collapsable-container" style={{ display: "flex", flexDirection: "column" }}>
							<div
								onClick={() => {
									setUserDataVisible(!userDataVisible);
								}}
								className="collapsable-list"
							>
								<div
									style={{
										display       : "flex",
										flexDirection : "row",
										margin        : "auto",
									}}
								>
									<label style={{ margin: "auto", paddingLeft: 24 }}>Dati utente</label>
									<div>{userDataVisible ? <ExpandLess /> : <ExpandMore />}</div>
								</div>
							</div>

							<Collapse in={userDataVisible} timeout="auto" unmountOnExit>
								<div style={{ display: "flex", justifyContent: "center" }}>
									<UserData userData={props.userData} />
								</div>
							</Collapse>
						</div>
					)}
					{props.showAddress && (
						<div id="collapsable-container" style={{ display: "flex", flexDirection: "column" }}>
							<div
								onClick={() => {
									setAddressVisible(!addressVisible);
								}}
								className="collapsable-list"
							>
								<div
									style={{
										display       : "flex",
										flexDirection : "row",
										margin        : "auto",
									}}
								>
									<label style={{ margin: "auto", paddingLeft: 24 }}>
										Dati indirizzo (spedizione)
									</label>
									<div>{addressVisible ? <ExpandLess /> : <ExpandMore />}</div>
								</div>
							</div>

							<Collapse in={addressVisible} timeout="auto" unmountOnExit>
								<div
									style={{
										display        : "flex",
										justifyContent : "center",
									}}
								>
									{shippingNationalityFlag ? (
										<div>
											{" "}
											<Typography className="p-y-10">
												<strong>Indirizzo:</strong>
												{` ${props.shippingAddress.address}`}
											</Typography>
										</div>
									) : (
										<ViewAddress noSearch={props.noSearch} address={props.shippingAddress} />
									)}
								</div>
							</Collapse>
						</div>
					)}
					<div
						id="collapsable-container"
						className="mb-40"
						style={{
							display       : "flex",
							flexDirection : "column",
						}}
					>
						<div
							onClick={() => {
								setDataVisible(!dataVisible);
							}}
							className="collapsable-list"
						>
							<div
								style={{
									display       : "flex",
									flexDirection : "row",
									margin        : "auto",
								}}
							>
								<label style={{ margin: "auto", paddingLeft: 24 }}>Dati indirizzo (fatturazione)</label>
								<div>{dataVisible ? <ExpandLess /> : <ExpandMore />}</div>
							</div>
						</div>

						<Collapse in={dataVisible} timeout="auto" unmountOnExit>
							<div style={{ display: "flex", justifyContent: "center" }}>
								{taxAddressNationalityFlag ? (
									<div>
										{" "}
										<Typography className="p-y-10">
											<strong>Indirizzo:</strong>
											{` ${taxAddress.address}`}
										</Typography>
									</div>
								) : (
									<ViewAddress address={taxAddress} noSearch={props.noSearch} />
								)}
							</div>
						</Collapse>
					</div>
				</div>
			) : (
				!success && (
					<div
						style={{
							display        : "flex",
							flexDirection  : "column",
							justifyContent : "center",
							alignItems     : "center",
							alignContent   : "center",
							height         : 250,
						}}
					>
						<Levels size={100} />
					</div>
				)
			)}

			<div style={{ display: loading && "none" }} className="footer-modal">
				{useCredits && creditToUse > 0 && paypalAmount <= 0 ? (
					<Button
						variant="contained"
						color="primary"
						className="payment-credit-button"
						disabled={creditLoading}
						onClick={payWithCredits}
					>
						Paga con Crediti
					</Button>
				) : (
					<PaypalBtn
						history={history}
						orderID={props.orderId}
						paymentType={props.paymentType}
						amount={paypalAmount.toFixed(2)}
						onClick={() => {
							setLoading(true);
							setButtonClicked(true);
							if (props.setError) props.setError(false);
						}}
						clientId={props.payClientId || defaultID}
						currency="EUR"
						onSuccess={(details, data) => {
							const paypal_payer    = {
								email_address : details.payer.email_address,
								payer_id      : details.payer.payer_id,
							};
							const paypal_captures = {
								status      : details.purchase_units[0].payments.captures[0].status,
								id          : details.purchase_units[0].payments.captures[0].id,
								create_time : details.purchase_units[0].payments.captures[0].create_time,
								amount      : details.purchase_units[0].payments.captures[0].amount,
							};
							const bodyData        = {
								orderid         : props.orderId,
								paypal_payer    : JSON.stringify(paypal_payer),
								paypal_captures : JSON.stringify(paypal_captures),
							};
							if (useCredits && creditToUse > 0) {
								bodyData.useCredits = "1";
								bodyData.creditAmount = creditToUse.toFixed(2);
							}
							if (props.memorialType) {
								bodyData.memorialType = props.memorialType;
								bodyData.deceasedID   = props.deceasedId;
							}
							requests("post", "paypalUpdate", bodyData).then((data) => {
								if (data.response === "success") {
									completeSuccess(data);
								} else {
									setLoading(false);
									setCreditError(data.message || "Pagamento non riuscito.");
									if (props.setError) props.setError(false);
								}
							});
						}}
					/>
				)}
			</div>
			{success && props.successComponent(props.isRegistering, props.isAccount, history)}
		</div>
	);
}
